import { render, staticRenderFns } from "./ModalReserva.vue?vue&type=template&id=3ea71c83&"
import script from "./ModalReserva.vue?vue&type=script&lang=js&"
export * from "./ModalReserva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports